import { Parcel } from "../../../../model/parcel";
import { IParcelDocumentProvider } from "./parcel-document-provider-interface";
import { parcelsService } from "../../../../services/parcels";
import { ParcelDocument } from "./parcel-document";
import { MultiParcelDocument } from "./multiparcel-document";
import { DocumentFormat } from "../document-printer";
import { IMultiParcelDocumentProvider } from "./multiparcel-document-provider-interface";
import { ParcelDetailsArrangement } from "../../../../model/parcel-details-arrangement";

class PdfPreparationOrderAndLabelProvider implements IParcelDocumentProvider, IMultiParcelDocumentProvider {
    public hasLabel = true;
    public hasPreparationOrder = true;

    public async fetch(operationCode: string, batchId: number, parcel: Parcel): Promise<ParcelDocument> {
        const response = await parcelsService.multipageDocument(operationCode, batchId, [parcel.id], "LabelAndPreparationOrderOnConsecutivePages",
            [ParcelDetailsArrangement.createFromParcel(parcel)]);

        return new ParcelDocument(parcel.id, DocumentFormat.PdfLandscape, response.file);
    }

    public async fetchMultiparcel(operationCode: string, batchId: number, parcel: Parcel[]): Promise<MultiParcelDocument> {
        const response = await parcelsService.multipageDocument(operationCode, batchId, parcel.map(p => p.id), "LabelAndPreparationOrderOnConsecutivePages",
            parcel.map(p => ParcelDetailsArrangement.createFromParcel(p)));

        return new MultiParcelDocument(response.succeededParcelIds, DocumentFormat.PdfLandscape, response.file);
    }
}

export const pdfPreparationOrderAndLabelProvider = new PdfPreparationOrderAndLabelProvider();
